export default "__VITE_ASSET__2559edb0__"